import CheckboxInput from 'src/Member/components/common/checkbox';

const GridColumnOptions = (props) => {
  return (
    <CheckboxInput
      label={props.Optionlabel}
      className="cursor-pointer d-flex show-hide-options-names"
      value={props.optionText}
      name={props.optionText}
      onChange={() => {
        props.optionChangeHandler(props.optionText);
      }}
      checked={props.gridColumnsDisplay[props.optionText] ? true : false}
    />
  );
};
export default GridColumnOptions;
